export default "__VITE_ASSET__CZXEtklC__"